import { HeistLocation, HeistReward, HeistSkill } from "../../models/item-data-models";

export const heistLocations: { name: HeistLocation, skills: HeistSkill[] }[] = [];
export const heistRewards: { skill: HeistSkill, rewards: HeistReward[] }[] = [];
